



















































































































































import axios from 'axios';
import EventBus from '@/eventBus';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';

export default {
    name: 'AdminSettingsFeatures',
    components: {
        CoCard,
        CoConfirmation,
        CoHeadline,
        CoLink,
        CoLoadingIndicator,
        CoSwitch,
        CoText,
    },
    data() {
        return {
            space: null,
            initialSpace: null,
            loading: false,
            marketSwitchKey: 0,
        };
    },
    props: {
        showTitle: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        showMarketCard() {
            return !!this.initialSpace?.MarkeplaceOn;
        },
        // Use localized Help Center articles when a translation is available.
        featureHelpLinks() {
            if (this.$i18n.locale.startsWith('de')) {
                return {
                    bookings:
                        'https://help.coapp.io/de/articles/7991656-wie-man-den-buchungskalender-nutzt-und-die-eigenen-ressourcen-buchbar-macht',
                    events: 'https://help.coapp.io/de/articles/10130620-anleitung-erstellen-und-veroffentlichen-einer-veranstaltung-auf-coapp',
                    market: 'https://help.coapp.io/de/articles/10085636-was-ist-der-markt-und-wie-funktioniert-er',
                    matching: 'https://help.coapp.io/en/articles/12819118-how-the-matchmaking-feature-works',
                    pages: 'https://help.coapp.io/de/articles/9470930-seiten-erstellen-verwalten-und-mit-exklusiven-inhalten-erweitern',
                };
            }

            return {
                bookings:
                    'https://help.coapp.io/en/articles/7991656-how-to-use-the-booking-calendar-and-make-your-resources-bookable',
                events: 'https://help.coapp.io/en/articles/10130620-creating-and-publishing-an-event-on-coapp',
                market: 'https://help.coapp.io/en/articles/10085636-what-is-the-market-and-how-does-it-work',
                matching: 'https://help.coapp.io/en/articles/12819118-how-the-matchmaking-feature-works',
                pages: 'https://help.coapp.io/en/articles/9470930-create-and-manage-pages',
            };
        },
    },
    mounted() {
        this.getSpaceSettings();
    },
    methods: {
        // Normalize feature flags so the switches always work with booleans.
        normalizeSpaceSettings(spaceSettings) {
            return {
                ...spaceSettings,
                BookingOn: !!spaceSettings?.BookingOn,
                MarkeplaceOn: !!spaceSettings?.MarkeplaceOn,
                EventsOff: !!spaceSettings?.EventsOff,
                MatchingOff: !!spaceSettings?.MatchingOff,
                PagesOff: !!spaceSettings?.PagesOff,
            };
        },
        pickInitialFeatureSettings(spaceSettings) {
            return {
                BookingOn: !!spaceSettings?.BookingOn,
                MarkeplaceOn: !!spaceSettings?.MarkeplaceOn,
                EventsOff: !!spaceSettings?.EventsOff,
                MatchingOff: !!spaceSettings?.MatchingOff,
                PagesOff: !!spaceSettings?.PagesOff,
            };
        },
        getSpaceSettings() {
            this.loading = true;
            axios
                .get('/admin/space/settings', {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    if (response && response.data) {
                        this.space = this.normalizeSpaceSettings(response.data);
                        this.initialSpace = this.pickInitialFeatureSettings(response.data);
                    }
                })
                .catch(() => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.spaceSettingsLoadFailed'),
                        Details: '',
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // Save a switch immediately and restore its previous value if the request fails.
        saveFeatureSetting(featureName, value) {
            const previousValue = this.space[featureName];
            this.$set(this.space, featureName, value);
            this.loading = true;
            axios
                .put('/admin/space/settings', JSON.stringify(this.space), {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    if (response && response.data) {
                        this.space = this.normalizeSpaceSettings(response.data);
                        this.initialSpace = this.pickInitialFeatureSettings(response.data);
                    }
                    // Update the shared feature state immediately so navigation reacts without a reload.
                    this.$store.commit('GETSPACE', {
                        ...this.$store.state.space,
                        ...this.space,
                    });
                    this.redirectFromDisabledFeature(featureName, value);
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.changessaved'),
                        Details: '',
                    });
                })
                .catch(() => {
                    this.$set(this.space, featureName, previousValue);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.spaceSettingsSaveFailed'),
                        Details: '',
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // Leave a member-facing feature route as soon as that feature is disabled.
        redirectFromDisabledFeature(featureName, value) {
            const routePatterns = {
                BookingOn: [/^\/booking-calendar/, /^\/profile\/my-bookings/],
                EventsOff: [/^\/events?(\/|$)/, /^\/profile\/my-events/],
                MarkeplaceOn: [/^\/(jobs?|market)(\/|$)/, /^\/market-item-as-post/, /^\/submit-(job|market-item)/],
                PagesOff: [/^\/(channels?|pages?|project)(\/|$)/, /^\/create\/page/, /^\/profile\/my-pages/],
            };
            const isDisabled = featureName.endsWith('Off') ? value : !value;

            if (isDisabled && routePatterns[featureName]?.some((pattern) => pattern.test(this.$route.path))) {
                this.$router.replace(featureName === 'EventsOff' ? '/not-found/event' : '/error404');
            }
        },
        // Disabling the sunsetted Market feature is permanent, so require confirmation before saving.
        handleMarketSettingChange(value) {
            if (value) {
                this.saveFeatureSetting('MarkeplaceOn', true);
                return;
            }

            this.marketSwitchKey += 1;
            this.$refs['disable-market-confirmation'].show();
        },
    },
};
